<style>
.modal-create-task {
  overflow-y: auto !important;
}

.modal-create-task {
  width: 90vw;
  height: 90vh !important;
}



.p-select {
  width: 100%;
}

.p-textarea {
  background: #fff;
  width: 100% !important;
}

.p-editor .p-editor-content.ql-disabled .ql-editor {
  background: var(--p-select-disabled-background)
}

label {
  font-size: var(--p-floatlabel-active-font-size);
  font-weight: var(--p-floatlabel-label-active-font-weight);
}


.p-message-error {
  color: #dc2626;
  font-size: 14px;
}

.p-message-content {
  height: fit-content !important;
}

.col-bottoni {
  display: flex;
  grid-column-gap: 20px;
  justify-content: end;
}

.close {
  text-align: right;
  margin-bottom: 20px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
}

.card-body {
  position: relative;
  padding: 20px;
}
</style>

<template>
  <div v-if="show" id="simple-modal-overlay" class="k-overlay" @click="annulla"></div>
  <div v-if="show" id="simple-modal" class="card-img-overlay popup-global-position modal-create-task">
    <div class="card mb-4">
      <div class="card-body p-3">
        <div class="close" @click="annulla()">
          <i class="pi pi-times" style="font-size: 20px"></i>
        </div>
        <h4>Aggiungi un messaggio al Task Sprint</h4>
        <CustomForm v-slot="$form" :resolver="resolver" @submit="onFormSubmit"
          class="flex flex-col gap-4 w-full md:w-56" style="margin-top: 20px;">
          <div class="row">
            <div class="col-12">
              <div class="flex flex-col gap-1" style="display: flex; flex-direction: column;">
                <FloatLabel class="w-full" variant="on">
                  <CustomTextArea name="messaggio" rows="5" cols="10" />
                  <label for="over_label">Messaggio</label>
                </FloatLabel>
                <Message v-if="$form.messaggio?.invalid" severity="error" variant="simple" size="small">Inserire un
                  messaggio per la chiusura del Task Sprint</Message>
              </div>
            </div>
            <div class="col-12 mt-5 col-bottoni">
              <CustomButton type="submit" severity="primary" label="Conferma"></CustomButton>
              <CustomButton @click="annulla()" severity="secondary" label="Annulla"></CustomButton>
            </div>
          </div>
        </CustomForm>
      </div>
    </div>
  </div>
</template>
<script>
import CustomButton from 'primevue/button';
import Message from 'primevue/message';
import CustomTextArea from 'primevue/textarea';
import { Form as CustomForm } from '@primevue/forms';
import FloatLabel from 'primevue/floatlabel';
import * as $ from 'jquery';
import { ref } from 'vue';
export default {
  name: "KModalMessaggioTask",
  components: { CustomForm, FloatLabel, Message, CustomTextArea, CustomButton },
  data() {
    return {
      status: '',
      task: null,
      $form: ref(),
      show: false,
      initialValues: ref({

      })
    }
  },
  setup() {
    return {
    }
  },
  mounted() {

  },
  created() {
    $(document).keyup(function (e) {
      if (e.key === "Escape" && this.show) {
        this.annulla();
      }
    }.bind(this));

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'startInsertMessaggioTS') {
        this.task = { ...mutation.payload };
        this.show = true;
      }

    });
  },
  methods: {
    resolver: ({ values }) => {
      const errors = {};
      if (!values.messaggio) {
        errors.messaggio = [{ message: 'Inserire un messaggio.' }];
      }
      return {
        errors
      };
    },
    onFormSubmit({ values, states, valid, errors }) {
      if (valid) {
        this.task.el.messaggio = states.messaggio.value;
        this.$store.dispatch("updateStatus", {
          ...this.task.el, taskStatus: this.task.newStatus,
          oldStatus: this.task.oldStatus
        });
        if(sessionStorage.getItem('isIframe')==='true'){
          this.$confirm.require({
            message: "Vuoi timbrare l'attività?",
            header: 'Attenzione!',
            icon: 'pi pi-exclamation-triangle',
            blockScroll: true,
            rejectProps: {
              label: 'No',
              severity: 'secondary',
              outlined: true
            },
            acceptProps: {
              label: 'Si'
            },
            accept: () => {
              window.parent.postMessage({
                operation:'timbraturaTaskSprint',
                task:JSON.stringify(this.task.el)
              }, process.env.VUE_APP_QUIK_URL);
            },
            reject: () => {
            }
          });
        }
        //this.task=null;
        this.show = false;
        // if(this.modifica===true){
        //   nuovoTaskSprint.id=this.taskDaDuplicare.id;
        //   nuovoTaskSprint.oldDescrizione=this.taskDaDuplicare.descrizione;
        //   this.$store.dispatch('editTask',{...nuovoTaskSprint});
        //   //console.log("Modifica: ", nuovoTaskSprint);
        // }else{
        //   this.$store.dispatch('createTask',{...nuovoTaskSprint});
        // }
      }
    },
    annulla() {
      this.task = null;
      this.show = false;
      let tasks = this.$store.getters.getAllTasks();
      this.$store.dispatch("tasksLoaded", tasks);
      $('html').css('overflow', 'auto')
    },
  }
}
</script>